import React from "react";
import BookStore from "../../stores/book-store";
import Dispatcher from "../../dispatcher";

var Tooltip = require("../ui_elements/tooltip").Tooltip;
var TooltipMixin = require("../ui_elements/tooltip").TooltipMixin;
var Menu = require("../ui_elements/menu").Menu;
var MenuMixin = require("../ui_elements/menu").MenuMixin;
var MenuList = require("../ui_elements/menu-list");
var MenuHeader = require("../ui_elements/menu-header");
var Isvg = require("../../../vendor/react-inlinesvg");
/*
  Renders a scrubber button
    props:
    state:
*/
class ZoomButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: this.props.id,
      zoomOutDisabled: false,
      zoomInDisabled: false,
      zoomOutScaleDisabled: false,
      zoomInScaleDisabled: false,
      zoomScale: 1
    };

    // TooltipMixin bindings
    this.showTooltip = TooltipMixin.showTooltip.bind(this);
    this.removeTooltip = TooltipMixin.removeTooltip.bind(this);
    this._addTooltipEvent = TooltipMixin._addTooltipEvent.bind(this);
    this._removeTooltipEvent = TooltipMixin._removeTooltipEvent.bind(this);

    // MenuMixin bindings
    this._toggleMenu = MenuMixin._toggleMenu.bind(this);
    this._showMenu = MenuMixin._showMenu.bind(this);
    this._removeMenu = MenuMixin._removeMenu.bind(this);
    this._redrawMenu = MenuMixin._redrawMenu.bind(this);

    // Method bindings
    this._pageReady = this._pageReady.bind(this);
    this._showScrubberOptionMenu = this._showScrubberOptionMenu.bind(this);
    this._addScrubberMenuTooltip = this._addScrubberMenuTooltip.bind(this);
    this._addScrubberViewTooltip = this._addScrubberViewTooltip.bind(this);
    this._resetZoom = this._resetZoom.bind(this);
    this._initializeFixedLayoutFit = this._initializeFixedLayoutFit.bind(this);
    this._fitHeightEvent = this._fitHeightEvent.bind(this);
    this._fitWidthEvent = this._fitWidthEvent.bind(this);
    this._zoomInTextEvent = this._zoomInTextEvent.bind(this);
    this._zoomOutTextEvent = this._zoomOutTextEvent.bind(this);
    this._zoomInScaleEvent = this._zoomInScaleEvent.bind(this);
    this._zoomOutScaleEvent = this._zoomOutScaleEvent.bind(this);
    this.setDPS = this.setDPS.bind(this);
    this._setTextSize = this._setTextSize.bind(this);
  }

  componentDidMount() {
    Dispatcher.bind(Dispatcher.BOOK_PAGE_READY, this._pageReady);
  }

  componentWillUnmount() {
    Dispatcher.unbind(Dispatcher.BOOK_PAGE_READY, this._pageReady);
  }

  componentDidUpdate() {}

  _pageReady() {
    this._initializeFixedLayoutFit();
  }

  _showScrubberOptionMenu(e) {
    if (typeof this.props.onAction === "function") {
      this.props.onAction(e);
    }
    this._removeTooltipEvent(e);
    this._toggleMenu(e, { closeCallback: this.props.onClose });
  }

  _addScrubberMenuTooltip(e) {
    if (!this.menuVisible) {
      this._addTooltipEvent(e);
    }
  }

  _addScrubberViewTooltip(e) {
    if (!this.menuVisible) {
      this._addTooltipEvent(e);
    }
  }

  _resetZoom() {
    const book = BookStore.get(this.props.isbn);

    if (Fraction.Brand.Scrubber.Buttons.zoom && book.vbkType !== "pbk") {
      book.viewer.Book.setTextSize(1);
      book.viewer.Book.setZoomScale(1);
    }

    book.viewer.Book.setZoomScale(1);

    this.setState({
      zoomOutDisabled: false,
      zoomInDisabled: false,
      zoomOutScaleDisabled: false,
      zoomInScaleDisabled: false,
      textSize: 1,
      zoomScale: 1
    });
  }

  _initializeFixedLayoutFit() {
    var fixedLayoutOptions = Fraction.Helpers.getDataObject(
      "User.Persist.FixedLayout"
    );

    if (fixedLayoutOptions.fit === "fitHeight") {
      this._fitHeightEvent("auto");
    } else if (fixedLayoutOptions.fit === "fitWidth") {
      this._fitWidthEvent("auto");
    } else if (fixedLayoutOptions.fit === "fitHeightZoomed") {
      this._fitHeightEvent("zoomed");
      this._setTextSize(this.state.textSize);
    } else if (fixedLayoutOptions.fit === "fitWidthZoomed") {
      this._fitWidthEvent("zoomed");
      this._setTextSize(this.state.textSize);
    } else {
      if (Fraction.Brand.Reader.defaultFit === "height") {
        this._fitHeightEvent("auto");
      } else {
        this._fitWidthEvent("auto");
      }
    }
  }

  // Fit Height button event
  _fitHeightEvent(method) {
    const book = BookStore.get(this.props.isbn);
    var fixedLayoutOptions = Fraction.Helpers.getDataObject(
      "User.Persist.FixedLayout"
    );
    if (method === "zoomed") {
      fixedLayoutOptions.fit = "fitHeightZoomed";
    } else {
      fixedLayoutOptions.fit = "fitHeight";
    }
    book.viewer.Book.fitToHeight();
    if (method !== "auto") {
      Fraction.Helpers.savePersist();
      Fraction.Reporter.gaEvent("reader/display/fit-height");
    }

    if (method !== "zoomed") {
      this._resetZoom();
    }

    this.forceUpdate();
  }

  // Fit Width button event
  // Possible values of method: 'zoomed', 'auto', [Click Object]
  _fitWidthEvent(method) {
    const book = BookStore.get(this.props.isbn);
    var fixedLayoutOptions = Fraction.Helpers.getDataObject(
      "User.Persist.FixedLayout"
    );
    if (method === "zoomed") {
      fixedLayoutOptions.fit = "fitWidthZoomed";
    } else {
      fixedLayoutOptions.fit = "fitWidth";
    }
    book.viewer.Book.fitToWidth();
    if (method !== "auto") {
      Fraction.Helpers.savePersist();
    }

    //Only send GA event if event was from click
    if (method !== "auto" && method !== "zoomed") {
      Fraction.Reporter.gaEvent("reader/display/fit-width");
    }

    if (method !== "zoomed") {
      this._resetZoom();
    }

    this.forceUpdate();
  }

  // Zoom In button event
  _zoomInTextEvent() {
    Fraction.Reporter.gaEvent("reader/display/zoomIn");
    const book = BookStore.get(this.props.isbn);
    book.viewer.Book.increaseTextSize(response => {
      // If successful click occurs, opposite zoom state should be enabled
      if (response.data.message === "text limit reached") {
        this.setState({
          zoomInDisabled: true,
          zoomOutDisabled: false,
          textSize: response.data.textSize
        });
      } else {
        this.setState({
          zoomInDisabled: false,
          zoomOutDisabled: false,
          textSize: response.data.textSize
        });
      }
    });

    const fixedLayoutOptions = Fraction.Helpers.getDataObject(
      "User.Persist.FixedLayout"
    );

    if (fixedLayoutOptions.fit === "fitHeight") {
      fixedLayoutOptions.fit = "fitHeightZoomed";
    } else if (fixedLayoutOptions.fit === "fitWidth") {
      fixedLayoutOptions.fit = "fitWidthZoomed";
    }

    this.forceUpdate();
  }

  // The following two are actaully text zoom, not zoom scaling
  // Zoom Out button event
  _zoomOutTextEvent() {
    Fraction.Reporter.gaEvent("reader/display/zoomOut");
    const book = BookStore.get(this.props.isbn);
    book.viewer.Book.decreaseTextSize(response => {
      // If successful click occurs, opposite zoom state should be enabled
      if (response.data.message === "text limit reached") {
        this.setState({
          zoomOutDisabled: true,
          zoomInDisabled: false,
          textSize: response.data.textSize
        });
      } else {
        this.setState({
          zoomOutDisabled: false,
          zoomInDisabled: false,
          textSize: response.data.textSize
        });
      }
    });

    const fixedLayoutOptions = Fraction.Helpers.getDataObject(
      "User.Persist.FixedLayout"
    );

    if (fixedLayoutOptions.fit === "fitHeight") {
      fixedLayoutOptions.fit = "fitHeightZoomed";
    } else if (fixedLayoutOptions.fit === "fitWidth") {
      fixedLayoutOptions.fit = "fitWidthZoomed";
    }

    this.forceUpdate();
  }

  // Zoom In button event
  _zoomInScaleEvent() {
    Fraction.Reporter.gaEvent("reader/display/zoomInScale");
    const book = BookStore.get(this.props.isbn);
    book.viewer.Book.increaseZoomScale(response => {
      // If successful click occurs, opposite zoom state should be enabled
      if (response.data.message === "zoom limit reached") {
        this.setState({
          zoomInScaleDisabled: true,
          zoomOutScaleDisabled: false,
          zoomScale: response.data.zoomScale
        });
      } else {
        this.setState({
          zoomInScaleDisabled: false,
          zoomOutScaleDisabled: false,
          zoomScale: response.data.zoomScale
        });
      }
    });

    const fixedLayoutOptions = Fraction.Helpers.getDataObject(
      "User.Persist.FixedLayout"
    );

    if (fixedLayoutOptions.fit === "fitHeight") {
      fixedLayoutOptions.fit = "fitHeightZoomed";
    } else if (fixedLayoutOptions.fit === "fitWidth") {
      fixedLayoutOptions.fit = "fitWidthZoomed";
    }

    this.forceUpdate();
  }

  // Zoom Out button event
  _zoomOutScaleEvent() {
    Fraction.Reporter.gaEvent("reader/display/zoomOutScale");
    const book = BookStore.get(this.props.isbn);
    book.viewer.Book.decreaseZoomScale(response => {
      // If successful click occurs, opposite zoom state should be enabled
      if (response.data.message === "zoom limit reached") {
        this.setState({
          zoomInScaleDisabled: false,
          zoomOutScaleDisabled: true,
          zoomScale: response.data.zoomScale
        });
      } else {
        this.setState({
          zoomInScaleDisabled: false,
          zoomOutScaleDisabled: false,
          zoomScale: response.data.zoomScale
        });
      }
    });

    const fixedLayoutOptions = Fraction.Helpers.getDataObject(
      "User.Persist.FixedLayout"
    );

    if (fixedLayoutOptions.fit === "fitHeight") {
      fixedLayoutOptions.fit = "fitHeightZoomed";
    } else if (fixedLayoutOptions.fit === "fitWidth") {
      fixedLayoutOptions.fit = "fitWidthZoomed";
    }

    this.forceUpdate();
  }

  setDPS(enabled = false) {
    Fraction.Helpers.getDataObject("User.Persist.DPS")[this.props.isbn] = enabled;
    Fraction.Helpers.savePersist();
    const book = BookStore.get(this.props.isbn);
    book.viewer.Viewport.setDPS(enabled);
  }

  _setTextSize(level) {
    if (Fraction.Brand.Scrubber.Buttons.zoom) {
      const book = BookStore.get(this.props.isbn);
      book.viewer.Book.setTextSize(level, function(response) {}.bind(this));
    }
  }

  render() {
    const book = BookStore.get(this.props.isbn);

    var menuId = this.props.id + "-menu";
    var floatStyle = { float: "left" };

    var zoomTooltip = i18n.t("reader.buttons.zoom-tooltip");

    var showTextZoom;
    if (book.vbkType !== "pbk") {
      showTextZoom = true;
    } else {
      showTextZoom = false;
    }

    var fixedLayoutOptions = Fraction.Helpers.getDataObject(
      "User.Persist.FixedLayout"
    );

    var fitButtons = [];
    var shouldShowFitButtons = false;
    if (
      book.vbkType === "pbk" &&
      (Fraction.Brand.Scrubber.Buttons.fit_height ||
        Fraction.Brand.Scrubber.Buttons.fit_width)
    ) {
      shouldShowFitButtons = true;
    }

    if (Fraction.Brand.Scrubber.Buttons.fit_height) {
      fitButtons.push({
        id: "fit-height-button",
        label: i18n.t("reader.buttons.fit-height"),
        rank: 30,
        clickEvent: this._fitHeightEvent,
        checked:
          !fixedLayoutOptions.fit || fixedLayoutOptions.fit === "fitHeight"
      });
    }

    if (Fraction.Brand.Scrubber.Buttons.fit_width) {
      fitButtons.push({
        id: "fit-width-button",
        label: i18n.t("reader.buttons.fit-width"),
        rank: 20,
        clickEvent: this._fitWidthEvent,
        checked: fixedLayoutOptions.fit === "fitWidth"
      });
    }

    const dpsOn =
      Fraction.Brand.DoublePageSpread.enabled &&
      !!Fraction.Helpers.getDataObject("User.Persist.DPS")[this.props.isbn];

    const dpsAvailable =
      book.dpsAvailable && Fraction.Brand.DoublePageSpread.enabled;

    return (
      <span style={floatStyle}>
        <Tooltip tooltip={this.state.tooltip} />
        <button
          id={this.props.id}
          className={"scrubber-button noButton " + this.props.className}
          data-menu-id={menuId}
          onClick={this._showScrubberOptionMenu}
          onMouseEnter={this._addTooltipEvent}
          onMouseLeave={this._removeTooltipEvent}
          data-tooltip={this.props.tooltip}
          data-tooltip-location="top"
          aria-expanded={this.props["aria-expanded"]}
        >
          <Isvg src={"/img/reader_options.svg"}>NS</Isvg>
          <span className="offScreen">
            {i18n.t("reader.buttons.view-options")}
          </span>
        </button>
        <Menu
          key={menuId}
          menuId={menuId}
          direction="down"
          yOffset={14 - 10 * dpsAvailable}
          onRemove={this.props.onClick}
        >
          {showTextZoom && (
            <span>
              <MenuHeader
                key="menu-header-reader.buttons.resize-text"
                menu-tooltip={zoomTooltip}
              >
                {i18n.t("reader.buttons.resize-text")}
              </MenuHeader>
              <div className="zoom-buttons">
                <button
                  className="zoom-button noButton out"
                  onClick={this._zoomOutTextEvent}
                  disabled={this.state.zoomOutDisabled}
                >
                  <span className="offScreen">
                    {i18n.t("reader.buttons.decrease-font")}
                  </span>
                </button>
                <button
                  className="zoom-button noButton in"
                  onClick={this._zoomInTextEvent}
                  disabled={this.state.zoomInDisabled}
                >
                  <span className="offScreen">
                    {i18n.t("reader.buttons.increase-font")}
                  </span>
                </button>
              </div>
            </span>
          )}
          <MenuHeader key="menu-header-reader.buttons.zoom">
            {i18n.t("reader.buttons.zoom")}
          </MenuHeader>
          <div id="zoom-percentage-container">
            <button
              className="zoom-minus noButton"
              onClick={this._zoomOutScaleEvent}
              disabled={this.state.zoomOutScaleDisabled}
            >
              <Isvg src={"/img/zoom_out.svg"}>NS</Isvg>
              <span className="offScreen">
                {i18n.t("reader.buttons.zoom-out")}
              </span>
            </button>
            <button
              className="zoom-plus noButton"
              onClick={this._zoomInScaleEvent}
              disabled={this.state.zoomInScaleDisabled}
            >
              <Isvg src={"/img/zoom_in.svg"}>NS</Isvg>
              <span className="offScreen">
                {i18n.t("reader.buttons.zoom-in")}
              </span>
            </button>
            <div className="zoom-percentage-aligner">
              <div className="zoom-percentage">
                {this.state.zoomScale * 100 + "%"}
              </div>
            </div>
          </div>
          {dpsAvailable && (
            <MenuHeader key="menu-header-reader.buttons.dps">
              {i18n.t("reader.buttons.dps")}
            </MenuHeader>
          )}
          {dpsAvailable && (
            <div id="dps-container">
              <button
                className={`${dpsOn ? "" : "selected "}noButton`}
                onClick={() => this.setDPS(false)}
                disabled={!dpsOn}
              >
                <Isvg src={"/img/page_layout-page.svg"}>NS</Isvg>
                <span className="offScreen">
                  {i18n.t("reader.buttons.zoom-out")}
                </span>
              </button>
              <div id="separator" />
              <button
                className={`${dpsOn ? "selected " : ""}noButton`}
                onClick={() => this.setDPS(true)}
                disabled={!!dpsOn}
              >
                <Isvg src={"/img/page_layout-spread.svg"}>NS</Isvg>
                <span className="offScreen">
                  {i18n.t("reader.buttons.zoom-in")}
                </span>
              </button>
            </div>
          )}
          {shouldShowFitButtons && (
            <MenuList key="fit-menu-list" items={fitButtons} />
          )}
        </Menu>
      </span>
    );
  }
}

module.exports = ZoomButton;
